import React from "react";
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import {useValue} from "@morningtrain/react-resources";

function Html(props) {
    const {name, defaultValue} = props;

    let value = useValue(name, defaultValue);

    return (
        <div className={props.className} dangerouslySetInnerHTML={{__html: value}}/>
    );
}

Html.defaultProps = {
    defaultValue: null,
    className: '',
}

Html.propTypes = {
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.any,
    className: PropTypes.string
}

export default observer(Html);

